import type { EmployeeScore } from "../modules/points/types";
import { apiGet } from "./utils";

const DEFAULT_DAYS = 30;

export type EmployeePointsDateRange = { from: string; to: string };

function formatDateParam(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function defaultEmployeePointsDateRange(
  today: Date = new Date()
): EmployeePointsDateRange {
  const to = new Date(today);
  to.setDate(to.getDate() - 1);
  const from = new Date(to);
  from.setDate(from.getDate() - DEFAULT_DAYS);
  return {
    from: formatDateParam(from),
    to: formatDateParam(to),
  };
}

export const employeePointsApi = {
  getAll: async (
    dateRange?: EmployeePointsDateRange
  ): Promise<EmployeeScore[]> => {
    const { from: fromStr, to: toStr } =
      dateRange ?? defaultEmployeePointsDateRange();

    return apiGet<EmployeeScore[]>(
      `/api/v1/employee_points?from=${fromStr}&to=${toStr}`
    );
  },
};
